/**
 * Machines Tab Component
 * Affiche la liste des machines pour un client spécifique en réutilisant le composant principal
 */
import { Machines } from "../../../views/machine/Machines";

const MachinesTab = ({ data }: { data: EasyTech.Customer }) => {
  return <Machines customer={data} hideFilters={false} hideHeader={false} noPadding={true} />;
};

export default MachinesTab; 
